import React from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../../FontAwesomeIcons";
import moment from "moment";
import ModalPortalHOC from "../../../BaseComponents/ModalPortalHOC";
import ImageZoomPanel from "../../../BaseComponents/ImageZoomPanel";

export class ImageMessage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            hasIntersected: false,
            mediaUrl: null,
            isFullscreenMode: false,
        };
        this.containerRef = React.createRef();
        this.observer = null;
    }

    componentDidMount() {
        const node = this.containerRef.current;
        if (!node) return;

        if (!('IntersectionObserver' in window)) {
            this.setState({hasIntersected: true});
            return;
        }

        this.observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    obs.disconnect();
                    this.observer = null;
                    this.setState({hasIntersected: true});
                }
            });
        }, {rootMargin: '200px'});

        this.observer.observe(node);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.hasIntersected && !this.state.mediaUrl) {
            const mediaUrl = this.props.getMediaContentUrlAPI(this.props.messageData.id_messaggio);
            if (mediaUrl !== this.state.mediaUrl) {
                this.setState({mediaUrl});
            }
        }
    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }

    toggleFullscreenMode = () => {
        if (!this.state.mediaUrl) return;
        this.setState(prev => ({isFullscreenMode: !prev.isFullscreenMode}));
    }

    render() {
        const {isMine, messageData} = this.props;
        const {mediaUrl, isFullscreenMode} = this.state;
        const sendTime = moment(messageData.data_creazione).format('HH:mm');

        const placeholderStyle = {
            backgroundColor: '#f0f0f0',
            width: 250,
            height: 250,
            borderRadius: 15
        };

        const imageStyle = mediaUrl ? {
            backgroundImage: `url("${mediaUrl}")`,
            backgroundSize: 'cover',
            width: 250,
            height: 250,
            borderRadius: 15
        } : placeholderStyle;

        return (
            <React.Fragment>
                <div
                    ref={this.containerRef}
                    style={imageStyle}
                    className={"mb-2 cursor-pointer"}
                    onClick={mediaUrl ? this.toggleFullscreenMode : undefined}
                />
                <div className={"metadata"}>
                    {sendTime}&nbsp;
                    {
                        isMine &&
                        <FaSolidIcon name={messageData.letto === '1' ? 'check-double' : 'check'}/>
                    }
                </div>
                <ModalPortalHOC>
                    {
                        isFullscreenMode &&
                        <ImageZoomPanel onDismiss={this.toggleFullscreenMode} src={mediaUrl}/>
                    }
                </ModalPortalHOC>
            </React.Fragment>
        );
    }
}

ImageMessage.propTypes = {
    isMine: PropTypes.bool,
    messageData: PropTypes.object.isRequired,
    getMediaContentUrlAPI: PropTypes.func.isRequired,
};
